import {
  GETPAYMENTGETWAY,
  CREATELINK,
  axios,
  baseURL,
  ServiceURL,
  SENDMAIL,
} from "./types";

export const getAllPaymentGetway = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setuppayment/getActive",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETPAYMENTGETWAY,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const createLink = (payload) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      method: "post",
      url: ServiceURL + "/api/hospitalpayments/createlink",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    };

    const response = await axios(config);

    console.log("--- BACKEND SE JAWAB ---", response);

    if (response.data && response.data.cf_link_id) {
      dispatch({
        type: CREATELINK,
        payload: response.data,
      });

      return response.data;
    } else {
      console.error("Backend response is missing 'cf_link_id':", response.data);
      throw new Error(
        response.data?.message ||
          "Failed to create link. Invalid response from server.",
      );
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    console.error("Error in createLink action:", errorMessage);
    dispatch({
      type: "CREATELINK_FAIL",
      payload: errorMessage,
    });

    throw error;
  }
};

export const sendMail = (payload) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    console.log("--- SENDING MAIL PAYLOAD ---", payload);
    
    const config = {
      method: "post",
      url: ServiceURL + "/api/hospitalNotification/email",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    };

    const response = await axios(config);

    console.log("--- SEND MAIL RESPONSE ---", response);
    console.log("--- SEND MAIL RESPONSE STATUS ---", response.status);
    console.log("--- SEND MAIL RESPONSE DATA ---", response.data);
    
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.data?.status === "success" ||
      response.data?.message?.toLowerCase().includes("success") ||
      response.data?.success === true
    ) {
      dispatch({
        type: SENDMAIL,
        payload: response.data,
      });

      return response.data;
    } else {
      console.error("Email API Error Response:", response.data);
      throw new Error(response.data?.message || "Failed to send email");
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    console.error("Error in sendMail action:", errorMessage);
    console.error("Full error object:", error);
    dispatch({
      type: "SENDMAILFAIL",
      payload: errorMessage,
    });

    throw error;
  }
};
